import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

import {
  FileSearch,
  BookOpenText,
  Briefcase,
  GraduationCap,
  CalendarCheck,
  Cpu,
  Code2,
  BookOpen,
  Bot,
  Users
} from "lucide-react";

const services = [
  {
    title: "Media Pembelajaran Robotik",
    icon: <Bot className="w-8 h-8 text-purple-600" />,
    description: "Pembuatan media pembelajaran berbasis robotik yang disesuaikan dengan tema pembelajaran."
  },
  {
    icon: <FileSearch className="w-10 h-10 text-blue-600" />,
    title: "Penelitian dan Survei",
    description:
      "GENIUS menawarkan jasa penelitian dan survei yang mendalam untuk mendukung pengambilan keputusan yang tepat. Kami membantu klien memahami tren, kebutuhan, dan tantangan melalui data yang valid dan analisis yang komprehensif."
  },
  {
    icon: <BookOpenText className="w-10 h-10 text-green-600" />,
    title: "Publikasi Online dan Cetak",
    description:
      "Sebagai penerbit profesional, GENIUS menyediakan layanan penerbitan baik dalam format digital maupun cetak. Kami membantu penulis, akademisi, dan organisasi dalam mempublikasikan karya mereka secara profesional dan sesuai standar."
  },
  {
    icon: <Briefcase className="w-10 h-10 text-purple-600" />,
    title: "Konsultan Non-Konstruksi",
    description:
      "Dengan tim ahli yang berpengalaman, GENIUS memberikan konsultasi strategis di berbagai sektor, termasuk manajemen, pendidikan, dan pengembangan masyarakat."
  },
  {
    icon: <GraduationCap className="w-10 h-10 text-yellow-600" />,
    title: "Pendidikan dan Pelatihan",
    description:
      "GENIUS menyelenggarakan program pendidikan dan pelatihan yang dirancang untuk meningkatkan kompetensi individu dan tim. Fokus kami meliputi pengembangan keterampilan teknis, manajerial, dan soft skills."
  },
  {
    icon: <CalendarCheck className="w-10 h-10 text-pink-600" />,
    title: "Event Organizer",
    description:
      "Kami mengorganisasi berbagai acara, mulai dari seminar, workshop, hingga konferensi berskala nasional dan internasional. GENIUS menjamin pelaksanaan acara yang profesional dan berkesan."
  },
  {
    icon: <Cpu className="w-10 h-10 text-red-600" />,
    title: "Teknologi",
    description:
      "GENIUS mendukung transformasi digital melalui layanan pengembangan teknologi. Kami menawarkan solusi inovatif, seperti aplikasi, website, dan sistem informasi yang disesuaikan dengan kebutuhan klien."
  }
];

const coreServices = [
  // {
  //   title: "Pembuatan Website",
  //   icon: <Code2 className="w-8 h-8 text-blue-600" />,
  //   description: "Kami membuat website edukatif, informatif, hingga e-commerce berbasis kebutuhan Anda."
  // },
  // {
  //   title: "Penelitian dan Survey",
  //   icon: <BookOpen className="w-8 h-8 text-green-600" />,
  //   description: "Kami bantu proses riset, survey lapangan, dan analisis data untuk proyek atau bisnis Anda."
  // },
  {
    title: "Media Pembelajaran Robotik",
    icon: <Bot className="w-8 h-8 text-purple-600" />,
    description: "Pembuatan media pembelajaran berbasis robotik yang disesuaikan dengan tema pembelajaran."
  },
  // {
  //   title: "Penyelenggaraan Pelatihan",
  //   icon: <Users className="w-8 h-8 text-yellow-600" />,
  //   description: "Pelatihan IT, edukasi digital, coding untuk siswa, guru, dan profesional secara langsung atau daring."
  // }
];

export default function Services3() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const parallaxRef = useRef<HTMLDivElement>(null);
  const coreServiceRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // const section = sectionRef.current;
    const parallax = parallaxRef.current;
    const coreServicesCurrent = coreServiceRef.current;
    // if (!section || !parallax) return;
    
    if (!coreServicesCurrent || !parallax) return;

    const listItems = gsap.utils.toArray<HTMLElement>(".service-item");
    const slides = gsap.utils.toArray<HTMLElement>(".service-slide");

    gsap.set(".service-fill", { scaleY: 0 });

    const tl = gsap.timeline({
      scrollTrigger: {
        // trigger: section,
        trigger: coreServicesCurrent,
        start: "top top", // artinya: saat Layanan Inti mulai menyentuh bawah layar
        end: "+=200%",
        pin: true,
        scrub: true
      }
    });

    listItems.forEach((item, index) => {
      if (index > 0) {
        tl.set(item, { color: "#DE3433" }, 0.5 * index)
          .to(slides[index], { autoAlpha: 1, duration: 0.2 }, "<")
          .set(listItems[index - 1], { color: "#121212" }, "<")
          .to(slides[index - 1], { autoAlpha: 0, duration: 0.2 }, "<");
      } else {
        tl.set(item, { color: "#DE3433" }, 0.01)
          .to(slides[index], { autoAlpha: 1, duration: 0.2 }, "<");
      }
    });

    tl.to({}, {}).to(
      ".service-fill",
      {
        scaleY: 1,
        transformOrigin: "top left",
        ease: "none",
        duration: tl.duration() - 0.5
      },
      0
    );

    gsap.to(parallax, {
      y: -100,
      ease: "none",
      scrollTrigger: {
        // trigger: section,
        trigger: coreServicesCurrent,
        start: "top bottom",
        end: "bottom top",
        scrub: true
      }
    });

    const isMobile = window.innerWidth < 1024;
    const listContainer = document.querySelector(".mobile-scroll-list");
    if (isMobile && listContainer) {
      const items = gsap.utils.toArray<HTMLElement>(".service-item");

      items.forEach((item) => {
        ScrollTrigger.create({
          trigger: item,
          scroller: listContainer,
          start: "left center",
          end: "right center",
          onEnter: () => item.classList.add("text-primary", "font-bold"),
          onLeave: () => item.classList.remove("text-primary", "font-bold"),
          onEnterBack: () => item.classList.add("text-primary", "font-bold"),
          onLeaveBack: () => item.classList.remove("text-primary", "font-bold")
        });
      });
    }

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  return (
    <>
      <section id="services" ref={coreServiceRef} className="relative z-0 py-24 px-4 sm:px-8 overflow-hidden">
      {/* <section id="services" ref={sectionRef} className="relative z-0 py-24 px-4 sm:px-8 overflow-hidden"> */}
        <div
          ref={parallaxRef}
          className="absolute top-[16vh] left-4 right-4 sm:left-8 sm:right-8 md:left-12 md:right-12 lg:left-20 lg:right-20 -bottom-12 bg-primaryGray backdrop-blur-sm rounded-2xl opacity-80"
        />

        <div className="relative z-10 text-center mb-4">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-800">Layanan Kami</h2>
          <div className="w-24 h-1 bg-primary mx-auto mt-4 rounded-full" />
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">Bidang Layanan Utama.</p>
        </div>
      
  
        <div className="relative z-10 flex flex-col lg:flex-row gap-6 lg:gap-10 w-[95%] sm:max-w-6xl mx-auto bg-white/30 rounded-xl shadow-lg p-4 sm:p-6 lg:p-8 border border-gray-100 transparent">
          <ul className="mobile-scroll-list list-none text-[12px] text-justify sm:text-lg font-semibold grid grid-cols-2 sm:grid-cols-2 lg:flex lg:flex-col gap-4 lg:gap-6 ml-0 lg:ml-6 text-primaryGray overflow-x-auto lg:overflow-visible whitespace-nowrap scroll-smooth">
            {services.map((service, idx) => (
              <li className="service-item snap-start cursor-pointer transition-colors duration-300 hover:text-primary whitespace-nowrap" key={idx}>
                {service.title}
              </li>
            ))}
          </ul>

          <div className="service-fill absolute left-1 top-1 w-1 h-[43vh] bg-gradient-to-b from-primary to-primaryGray rounded-full text-lg items-center text-center mr-6"></div>
          <div className="flex-1 relative min-h-[300px] w-50% sm:w-[75%] md:w-[50%] lg:w-[40%] md:w-full">
            {services.map((service, idx) => (
              <div
                key={idx}
                className={`service-slide absolute inset-0 transition-opacity bg-gradient-to-br from-white via-gray-50 to-gray-100 opacity-0 shadow-lg rounded-xl p-6 sm:p-8 md:p-10 border border-gray-200 ${idx === 0 ? "opacity-100" : ""}`}
              >
                <div className="mb-4">{service.icon}</div>
                <h3 className="text-xl sm:text-2xl font-bold mb-2 text-gray-800">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed text-sm sm:text-base">{service.description}</p>
              </div>
            ))}
          </div>
        </div>

      </section>

    </>
  );
}
